import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">


                                            <div className="border_subtitle">Talk to a role model</div>
                                            <p>Is there someone who you know who influences people easily? If
                                                so, you could discuss this topic
                                                with them. They may give you advice that helps you be more
                                                effective.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Having completed the exercises in this tool an important next
                                                step is to consider what you can do to improve. Make learning
                                                how to influence people in different ways part of your personal
                                                development plan. If you don’t have a plan like this you could
                                                put one together, using this topic as a starting point. Ensure
                                                you give yourself clear objectives and practical things to do
                                                that will help you make real progress.</p>
                                            <div className="border_subtitle">Get feedback on your influencing
                                                style
                                            </div>
                                            <p>Have you asked other people how effective they think you are at
                                                influencing others – what you
                                                do well, what’s not so good, what you could do better? Even if
                                                you have in the past, this may be
                                                a good time to get a more up to date assessment. You can ask
                                                anyone but try to make sure that
                                                it’s someone you trust to be honest (but be prepared to have to
                                                ask for this). This could be your
                                                line manager, mentor, coach or colleagues, customers and
                                                friends. You may want more than one
                                                view to get different perspectives.</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Set a future date to review
                                                    your progress
                                                </div>
                                                <p>Ask people for comments and see if they’ve noticed any
                                                    changes. Make a note of any aspect that could still
                                                    improve.</p>

                                            </div>
                                            <div className="border_subtitle">Some tips to take away</div>
                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Know your strengths</div>
                                                <p>You will be more confident, comfortable and convincing in
                                                    your persuasion if you play to
                                                    your strengths. If you are analytical, use logic and
                                                    reasoning. If you are empathic, use active
                                                    listening and attend to the person’s feelings. If you are
                                                    creative and extrovert, look to make
                                                    an impression.</p>
                                                <div className="uiheading">
                                                    <div className="border_subtitle">Know your audience</div>
                                                    <p>What strategies will work will depend on your audience as
                                                        well as your own ability to apply
                                                        your skills. This means that you need to gain an
                                                        understanding of their position, their likely
                                                        concerns, their motivations and their relationship with
                                                        you. If you can tap into what makes
                                                        them tick and allay their concerns then you are more
                                                        than half-way there.</p></div>

                                            </div>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}